import React, { useEffect, useRef, useState } from "react";
import "./AgencyBillingType.scss";
import DownArrowIcon from "../../../components/icons/DownArrowIcon";

const statusOptions = [
  { value: "all", label: "All" },
  { value: "payment_via_agency_payment_methods", label: "Payments via Agency Payment Methods" },
];

const AgencyBillingType = ({ formik }: { formik: any }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const selectedLabel = formik?.values?.billing_type
    ? statusOptions.find(
        (option) => option.value === formik.values.billing_type,
      )?.label
    : "Select Billing Type";

  const handleSelect = (value: string) => {
    formik.setFieldValue("billing_type", value);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="agent-contain-container" ref={containerRef}>
      <div className="agent-heading">
        <p>Billing type</p>
      </div>

      <div className="filter-search-listing">
        <input
          type="text"
          placeholder="Select Billing Type"
          className="filter-search-input"
          value={selectedLabel}
          onClick={() => setDropdownOpen(!dropdownOpen)}
          readOnly
        />
        <div
          className={`filter-down-arrow-icon ${dropdownOpen ? "open-box" : ""}`}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <DownArrowIcon />
        </div>
      </div>

      {dropdownOpen && (
        <div className="agent-list-container">
          {statusOptions.map((option) => (
            <div
              key={option.value}
              className={`agent-list-item ${
                formik.values.billing_type === option.value
                  ? "agent-list-item-active"
                  : ""
              }`}
              onClick={() => handleSelect(option.value)}
            >
              <p className="item-profile-name">{option.label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AgencyBillingType;
